import React from 'react';
import FadeOutErrorMessage from './FadeOutErrorMessage';

export default class ValidatedInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            requiredError: !this.hasValue(this.props.value),
            validationError: this.props.validate ? !this.props.validate(this.props.value) : false
        };

        this.onChange = this.onChange.bind(this);
        this.checkRequire = this.checkRequire.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.checkRequire(nextProps.value);
            if (!nextProps.value || this.state.validationError) {
                this.validate(nextProps.value);
            }
        }
    }

    onChange(event) {
        if (this.props.onChange) this.props.onChange(event.target.name, event.target.value);
    }

    checkRequire(value) {
        if (this.props.required) {
            this.setState({ requiredError: !this.hasValue(value) });
        }
    }

    hasValue(value) {
        let hasVal = value;
        if((value === '0' || value === 0) && !this.props.zeroAsValue) {
            hasVal = false;
        } else if (value instanceof Array) {
            hasVal = value.length;
        } else if (value instanceof Object) {
            hasVal = Object.keys(value).length;
        }
        return !!hasVal;
    }

    validate(value) {
        if (this.props.validated && this.props.validate) {
            this.setState({ validationError: !this.props.validate(value) });
        }
    }

    render() {
        const requiredErr = this.props.required && this.props.showRequiredError && this.state.requiredError;
        const validationErr = this.props.showValidationError && this.state.validationError;
        const input = React.cloneElement(this.props.input, {
            name: this.props.name,
            value: this.props.value,
            className: `${this.props.input.props.className || ""} ${(validationErr || requiredErr) ? " error-input" : ""}`,
            onChange: this.onChange,
            onBlur: e => this.validate(e.target.value),
            onKeyDown: e => {
                if (e.key === 'Enter')
                    this.validate(e.target.value);
                if (this.props.onKeyDown)
                    this.props.onKeyDown(e);
                if (this.props.input.props.onKeyDown)
                    this.props.input.props.onKeyDown(e);
            }
        });

        return (
            <div>
                {this.props.label && <label className={`input-label ${(validationErr || requiredErr) ? "error-label" : ""}`}>{this.props.label}</label>}
                {input}
                <FadeOutErrorMessage show={validationErr} message={this.props.errorMessage || 'Invalid entry'} />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/commonComponents/util/ValidatedInput.jsx